import {useEffect, useMemo, useRef, useState} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {getPropertyFaqQuestions} from "../../constants/property_faq_questions";
import {usePropertyFaqExperiment} from "../../hooks/use_property_faq_experiment";
import {propertyFaqAnalytics} from "../../tracking/property_faq_tracking";
import {PropertyDetailFaqItem} from "./PropertyDetailFaqItem";

import propertyFaqAvatar from "../../images/property_faq_avatar.svg";

interface IProps {
    property: {
        id: number;
        rooms: number;
        offer: {
            id: number;
            name: string;
            type: number;
            geo_point: {
                coordinates: [number, number];
            };
            vendor: {
                id: number;
                name: string;
            };
        };
    };
    onOpenMapModal?: () => void;
}

const PROPERTY_FAQ_WRAPPER_ID = "property-detail-faq-wrapper";

export const PropertyDetailFaq = (props: IProps) => {
    const {property, onOpenMapModal} = props;

    const [wasFaqVisible, setWasFaqVisible] = useState(false);
    const faqItems = useMemo(() => getPropertyFaqQuestions({offerType: property.offer.type, rooms: property.rooms}), [property.offer.type, property.rooms]);

    useElementWasVisible({
        ids: [PROPERTY_FAQ_WRAPPER_ID],
        onElementVisible: () => {
            setWasFaqVisible(true);
        },
        once: true,
        threshold: 0.05
    });

    const wasListViewTrackedRef = useRef(false);

    useEffect(() => {
        if (wasFaqVisible && faqItems.length > 0 && !wasListViewTrackedRef.current) {
            wasListViewTrackedRef.current = true;
            propertyFaqAnalytics.gtm.listView();
            propertyFaqAnalytics.amplitude.sectionView({
                itemId: property.offer.id,
                propertyId: property.id,
                products: faqItems.map((faqItem, index) => ({
                    answerContent: null,
                    index,
                    questionHeading: faqItem.question,
                    questionType: "default"
                }))
            });
        }
    }, [faqItems, property.id, property.offer.id, wasFaqVisible]);

    const {hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const {isResolved, isFaqEnabled, isAnswerGateDisabled} = usePropertyFaqExperiment();
    // Answers are gated strictly behind a verified phone number — a manual prices unlock does not apply here.
    // The `open` variants of the A/B test serve them to everyone instead.
    const canSeeAnswers = isAnswerGateDisabled || (isUserLoggedIn && hasPhoneVerified);

    if (faqItems.length === 0) {
        return null;
    }

    // The section is client only — the A/B test variant is resolved after hydration, so SSR emits just the anchor
    if (!isResolved) {
        return <section id="faq" className={faqSectionStyle} />;
    }

    if (!isFaqEnabled) {
        return null;
    }

    return (
        <section id="faq" className={faqSectionStyle}>
            <div data-id={PROPERTY_FAQ_WRAPPER_ID} className={faqCardStyle}>
                <div className={faqHeaderStyle}>
                    <img src={propertyFaqAvatar} alt="" width={56} height={56} className={faqAvatarStyle} />

                    <div className={faqHeaderTextStyle}>
                        <Text variant="headline_4" as="h2">
                            Najczęściej zadawane pytania
                        </Text>

                        <Text variant="info_txt_1" as="p">
                            Zebraliśmy {faqItems.length} najczęściej zadawanych pytań od naszych użytkowników
                        </Text>
                    </div>
                </div>

                <div className={faqListStyle}>
                    {faqItems.map((faqItem, index) => (
                        <PropertyDetailFaqItem
                            key={`${property.id}-${faqItem.id}`}
                            faqItem={faqItem}
                            questionPosition={index + 1}
                            canSeeAnswer={canSeeAnswers}
                            propertyId={property.id}
                            offerId={property.offer.id}
                            offerName={property.offer.name}
                            vendorId={property.offer.vendor.id}
                            vendorName={property.offer.vendor.name}
                            geoPointCoordinates={property.offer.geo_point.coordinates}
                            onOpenMapModal={onOpenMapModal}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

const faqSectionStyle = css({
    mb: 2,

    md: {
        mb: 3
    }
});

const faqCardStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 4,
    width: "100%",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    p: 1,

    md: {
        p: 2
    }
});

const faqHeaderStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 2
});

const faqAvatarStyle = css({
    flexShrink: 0
});

const faqHeaderTextStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const faqListStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%"
});
import {useEffect, useMemo, useRef, useState} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {getPropertyFaqQuestions} from "../../constants/property_faq_questions";
import {usePropertyFaqExperiment} from "../../hooks/use_property_faq_experiment";
import {propertyFaqAnalytics} from "../../tracking/property_faq_tracking";
import {PropertyDetailFaqItem} from "./PropertyDetailFaqItem";

import propertyFaqAvatar from "../../images/property_faq_avatar.svg";

interface IProps {
    property: {
        id: number;
        rooms: number;
        offer: {
            id: number;
            name: string;
            type: number;
            geo_point: {
                coordinates: [number, number];
            };
            vendor: {
                id: number;
                name: string;
            };
        };
    };
    onOpenMapModal?: () => void;
}

const PROPERTY_FAQ_WRAPPER_ID = "property-detail-faq-wrapper";

export const PropertyDetailFaq = (props: IProps) => {
    const {property, onOpenMapModal} = props;

    const [wasFaqVisible, setWasFaqVisible] = useState(false);
    const faqItems = useMemo(() => getPropertyFaqQuestions({offerType: property.offer.type, rooms: property.rooms}), [property.offer.type, property.rooms]);

    useElementWasVisible({
        ids: [PROPERTY_FAQ_WRAPPER_ID],
        onElementVisible: () => {
            setWasFaqVisible(true);
        },
        once: true,
        threshold: 0.05
    });

    const wasListViewTrackedRef = useRef(false);

    useEffect(() => {
        if (wasFaqVisible && faqItems.length > 0 && !wasListViewTrackedRef.current) {
            wasListViewTrackedRef.current = true;
            propertyFaqAnalytics.gtm.listView();
            propertyFaqAnalytics.amplitude.sectionView({
                itemId: property.offer.id,
                propertyId: property.id,
                products: faqItems.map((faqItem, index) => ({
                    answerContent: null,
                    index,
                    questionHeading: faqItem.question,
                    questionType: "default"
                }))
            });
        }
    }, [faqItems, property.id, property.offer.id, wasFaqVisible]);

    const {hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const {isResolved, isFaqEnabled, isAnswerGateDisabled} = usePropertyFaqExperiment();
    // Answers are gated strictly behind a verified phone number — a manual prices unlock does not apply here.
    // The `open` variants of the A/B test serve them to everyone instead.
    const canSeeAnswers = isAnswerGateDisabled || (isUserLoggedIn && hasPhoneVerified);

    if (faqItems.length === 0) {
        return null;
    }

    // The section is client only — the A/B test variant is resolved after hydration, so SSR emits just the anchor
    if (!isResolved) {
        return <section id="faq" className={faqSectionStyle} />;
    }

    if (!isFaqEnabled) {
        return null;
    }

    return (
        <section id="faq" className={faqSectionStyle}>
            <div data-id={PROPERTY_FAQ_WRAPPER_ID} className={faqCardStyle}>
                <div className={faqHeaderStyle}>
                    <img src={propertyFaqAvatar} alt="" width={56} height={56} className={faqAvatarStyle} />

                    <div className={faqHeaderTextStyle}>
                        <Text variant="headline_4" as="h2">
                            Najczęściej zadawane pytania
                        </Text>

                        <Text variant="info_txt_1" as="p">
                            Zebraliśmy {faqItems.length} najczęściej zadawanych pytań od naszych użytkowników
                        </Text>
                    </div>
                </div>

                <div className={faqListStyle}>
                    {faqItems.map((faqItem, index) => (
                        <PropertyDetailFaqItem
                            key={`${property.id}-${faqItem.id}`}
                            faqItem={faqItem}
                            questionPosition={index + 1}
                            canSeeAnswer={canSeeAnswers}
                            propertyId={property.id}
                            offerId={property.offer.id}
                            offerName={property.offer.name}
                            vendorId={property.offer.vendor.id}
                            vendorName={property.offer.vendor.name}
                            geoPointCoordinates={property.offer.geo_point.coordinates}
                            onOpenMapModal={onOpenMapModal}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

const faqSectionStyle = css({
    mb: 2,

    md: {
        mb: 3
    }
});

const faqCardStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 4,
    width: "100%",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    p: 1,

    md: {
        p: 2
    }
});

const faqHeaderStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 2
});

const faqAvatarStyle = css({
    flexShrink: 0
});

const faqHeaderTextStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const faqListStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%"
});
